export default "<div class=\"progress-cont\">\n    <div class=\"progress\" [style.width]=\"progress + '%'\">\n    </div>\n  </div>\n  "